export const GetOlderAdultsSelector = ({ olderadults: { GetOlderAdults } }) =>
  GetOlderAdults;
export const OlderAdultsSelector = ({ olderadults: { OlderAdults } }) =>
  OlderAdults;
